import React from 'react';

const EditPostModal = ({ post, editContent, setEditContent, onSave, onClose }) => {
  if (!post) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-lg p-6" data-testid="edit-post-modal">
        <h3 className="text-lg font-bold mb-4"><span className="font-arthaus">Edit Point</span></h3>
        <textarea
          value={editContent}
          onChange={e => setEditContent(e.target.value)}
          className="w-full border border-gray-200 rounded-xl p-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#4A90E2] resize-none"
          rows={4}
          data-testid="edit-post-textarea"
        />
        <div className="flex justify-end space-x-2 mt-4">
          <button onClick={onClose} className="px-4 py-2 text-sm text-gray-500 hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={onSave} data-testid="save-edit-btn" className="px-4 py-2 text-sm bg-gray-900 text-white rounded-lg hover:bg-gray-700">Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditPostModal;
